import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import axios from '@/lib/axios'
import { LoginParamsType, TokensType } from '@/types/auth'
import { getErrorMessage } from '@/lib/utils'

type LoginStateType = {
  isLoading: boolean
  response: TokensType | null
  error: {
    status?: number
    message: string
  } | null
}

type LoginStoreType = {
  loginState: LoginStateType
  login: (params: LoginParamsType) => Promise<TokensType>
  reset: () => void
}

const initialState: LoginStateType = {
  isLoading: false,
  response: null,
  error: null
}

const useLoginStore = create<LoginStoreType>()(
  devtools(set => ({
    loginState: initialState,
    login: async (params: LoginParamsType) => {
      set(() => ({
        loginState: {
          ...initialState,
          isLoading: true
        }
      }))

      try {
        const { data } = await axios.post('/auth/login', params)
        set(() => ({
          loginState: {
            ...initialState,
            response: data
          }
        }))

        return data
      } catch (error: any) {
        set(() => ({
          loginState: {
            ...initialState,
            error: {
              status: error.response?.status || 500,
              message: getErrorMessage(error)
            }
          }
        }))

        throw error
      }
    },
    reset: () => {
      set(() => ({
        loginState: initialState
      }))
    }
  }))
)

export default useLoginStore
